import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { useLocation } from 'react-router-dom';
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";
import { RingLoader } from 'react-spinners';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, TableFooter } from "@mui/material";
import { FormaDateBalanceSheet } from "../../../Common/FormatFunctions/FormatDate"
import PdfPreview from '../../../Common/PDFPreview';

const apikey = process.env.REACT_APP_API;

const AgripurchaseRegister = () => {
  const location = useLocation();
  const Company_Name = sessionStorage.getItem('Company_Name')
  const Company_GSTNO = sessionStorage.getItem('Company_GSTNO')
  const searchParams = new URLSearchParams(location.search);
  const fromDate = searchParams.get('fromDate');
  const toDate = searchParams.get('toDate');
  const company_Code = searchParams.get('companyCode');
  const YearCode = searchParams.get('yearCode');
  const acCode = searchParams.get('godoawnCode');
  const [pdfPreview, setPdfPreview] = useState(null);

  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [grandTotals, setGrandTotals] = useState({
   
    netBalance: 0,
    netSale: 0,
    netqntl: 0
  });

  const API_URL = `${apikey}/AgriPurchase_Register`;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear());
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    const fetchReportData = async () => {
      setLoading(true);
      setError('');
      try {
        const response = await axios.get(API_URL, {
          params: {
            from_date: fromDate,
            to_date: toDate,
            Company_Code: company_Code,
            Year_code: YearCode,
            godawncode: acCode
          },
        });
        setReportData(response.data);
      } catch (error) {
        console.error('Error fetching report:', error);
        setError('Error fetching report');
      } finally {
        setLoading(false);
      }
    };

    fetchReportData();
  }, [API_URL]);

  useEffect(() => {
    if (reportData.length > 0) {
      const totals = reportData.reduce(
        (acc, item) => {
        //   acc.TotalTaxable_Amt += Number(item.TaxableAmount) || 0;
        //   acc.CGSTAmt += Number(item.CGSTAmount) || 0;
        //   acc.SGSTAmt += Number(item.SGSTAmount) || 0;
          acc.netSale += Number(item.Sale) || 0;
          acc.netBalance += Number(item.Balance) || 0;
          acc.netqntl += Number(item.Purchase_Qntl) || 0;
          return acc;
        },
        {netqntl:0,netSale: 0,netBalance: 0}
        // { TotalTaxable_Amt: 0, CGSTAmt: 0, SGSTAmt: 0, IGSTAmt: 0, BillamountAmt: 0, netqntl: 0 }
      );

      setGrandTotals(totals);
    }
  }, [reportData]);

  const handleExportToExcel = () => {
  const wb = XLSX.utils.book_new();

  const headers = [
    "Bill No",
    "Date",
    "Party Name",
    "GST No",
    "Truck no",
    "Item Name",
    "Net Quintal",
    "Rate",
    "Dispatched",
    "Balance",
  ];

  // flatten grouped data
  const rows = [];

  Object.values(groupedReportData).forEach(({ items }) => {
    items.forEach(item => {
      rows.push({
        "Bill No": item.purcno,
        "Date": formatDate(item.Doc_Date),
        "Party Name": item.PartyName,
        "GST No": item.Gst_No,
        "Truck no": item.Truck_No,
        "Item Name": item.itemname,
        "Net Quintal": Number(item.Purchase_Qntl) || 0,
        "Rate": Number(item.Rate) || 0,
        "Dispatched": Number(item.Sale) || 0,
        "Balance": Number(item.Balance) || 0,
      });
    });
  });

  // add TOTAL row
  rows.push({
    "Bill No": "TOTAL",
    "Date": "",
    "Party Name": "",
    "GST No": "",
    "Truck no": "",
    "Item Name": "",
    "Net Quintal": Number(grandTotals.netqntl) || 0,
    "Rate": Number(grandTotals.Rate) || 0,
    "Dispatched": Number(grandTotals.netSale) || 0,
    "Balance": Number(grandTotals.netBalance) || 0,
  });

  const ws = XLSX.utils.json_to_sheet(rows, { header: headers });

  // column widths + alignment
  ws["!cols"] = [
    { wch: 12 },
    { wch: 12 },
    { wch: 30 },
    { wch: 18 },
    { wch: 25 },
    { wch: 14 },
    { wch: 14 },
    { wch: 14 },
  ];

  XLSX.utils.book_append_sheet(wb, ws, "Agri Purchase Register");
  XLSX.writeFile(wb, "Agri_Purchase_Register.xlsx");
};


 const handlePrint = () => {
  const companyName = Company_Name;
  const fromDateParam = searchParams.get('fromDate');
  const toDateParam = searchParams.get('toDate');
  
  const doc = generatePDFDocument(companyName, fromDateParam, toDateParam);
  const pdfUrl = URL.createObjectURL(doc);
  const printWindow = window.open(pdfUrl);
  printWindow.onload = function() {
    setTimeout(() => {
      printWindow.print();
    }, 500);
  };
};

const generatePDFDocument = (companyName, fromDate, toDate) => {
  const doc = new jsPDF("l", "mm", "a4"); // Landscape for wide table
  const pageWidth = doc.internal.pageSize.getWidth();

  /* ================= HEADER ================= */
  doc.setFontSize(12);
  doc.setFont(undefined, "bold");
  doc.text(companyName, pageWidth / 2, 12, { align: "center" });

  doc.setFontSize(10);
  doc.setFont(undefined, "normal");
  doc.text(`GSTN : ${Company_GSTNO}`, pageWidth / 2, 18, { align: "center" });

  doc.setFontSize(12);
  doc.setFont(undefined, "bold");
  doc.text("Purchase / Dispatch Register", pageWidth / 2, 26, { align: "center" });

  doc.setFontSize(10);
  doc.setFont(undefined, "normal");
  doc.text(
    `${FormaDateBalanceSheet(fromDate)} to ${FormaDateBalanceSheet(toDate)}`,
    pageWidth / 2,
    32,
    { align: "center" }
  );

  /* ================= TABLE DATA ================= */

  // TABLE HEADER (same as UI)
  const tableHead = [[
    "Bill No",
    "Date",
    "Customer / Party Name",
    "GST No",
    "Truck No",
    "Item Name",
    "Net Quintal",
    "Rate",
    "Dispatched",
    "Balance"
  ]];

  // TABLE BODY (same mapping as UI)
  const tableBody = [];

  Object.entries(groupedReportData).forEach(([key, { items }]) => {
    items.forEach(item => {
      tableBody.push([
        item.purcno,
        formatDate(item.Doc_Date),
        item.PartyName,
        item.Gst_No,
        item.Truck_No,
        item.itemname,
        formatReadableAmount(item.Purchase_Qntl),
        formatReadableAmount(item.Rate),

        formatReadableAmount(item.Sale),
        formatReadableAmount(item.Balance)
      ]);
    });
  });

  // TABLE FOOTER (Total row)
  const tableFoot = [[
    "",
    "",
    "Total",
    "",
    "",
    "",
    formatReadableAmount(grandTotals.netqntl),
    "",
    formatReadableAmount(grandTotals.netSale),
    formatReadableAmount(grandTotals.netBalance)
  ]];

  /* ================= AUTOTABLE ================= */
  doc.autoTable({
    startY: 38,
    head: tableHead,
    body: tableBody,
    foot: tableFoot,
    theme: "grid",

    styles: {
      fontSize: 8,
      cellPadding: 3,
      valign: "middle"
    },

    headStyles: {
      fillColor: [240, 240, 240],
      textColor: [0, 0, 0],
      fontStyle: "bold",
      halign: "center"
    },

    footStyles: {
      fillColor: [255, 255, 0],
      textColor: [0, 0, 0],
      fontStyle: "bold"
    },

    columnStyles: {
      0: { halign: "center" }, // Bill No
      1: { halign: "center" }, // Date
      2: { halign: "left"   }, // Party Name
      3: { halign: "left" }, // GST No

      4: { halign: "left"   }, // Item Name
      5: { halign: "right"  }, // Net Quintal
      6: { halign: "right"  }, // Dispatched
      7: { halign: "right"  },  // Balance
      8: {halign: "right"},
      9: {halign: "right"}

    }
  });

  /* ================= PREVIEW ================= */
  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  setPdfPreview(pdfUrl);
  return pdfBlob;
};


  const groupReportData = (data) => {
    const groupedData = {};
    data.forEach((item) => {
      const key = `${item.saleid}`;
      if (!groupedData[key]) {
        groupedData[key] = {
          items: [],
          totalQty: 0,
        };
      }
      groupedData[key].items.push(item);
      groupedData[key].totalQty += parseFloat(item.Bill_Amount) || 0;
    });
    return groupedData;
  };

  const groupedReportData = groupReportData(reportData);

  return (
    <div style={{marginTop:"-80px"}}>
      <Typography variant="h6" style={{ textAlign: 'center', fontSize: "24px", fontWeight: "bold" }}>{Company_Name}</Typography>
      <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px", textDecoration: 'underline', fontWeight: "550" }}>GSTN : {Company_GSTNO}</Typography>
      <Typography variant="h6" style={{ textAlign: 'center', fontSize: "20px", fontWeight: "bold" }}>Agri Purchase Register</Typography>
      <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px" }}>{FormaDateBalanceSheet(fromDate)} to {FormaDateBalanceSheet(toDate)}</Typography>

      <div className="mb-3 row align-items-center">
        <div className="col-auto">
          <button className="btn btn-secondary me-2" onClick={handlePrint}>
            Print
          </button>
          <button className="btn btn-success" onClick={handleExportToExcel}>
            Export to Excel
          </button>
          <button className="btn btn-secondary me-2" onClick={() => generatePDFDocument(Company_Name, fromDate, toDate)}>
            Preview PDF
          </button>
          {pdfPreview && (
            <PdfPreview
              pdfData={pdfPreview}
              apiData={reportData[0]}
              label={"AgriPurchaseRegister"}
            />
          )}
        </div>
      </div>

      <div style={{
        maxHeight: 'calc(100vh - 200px)',
        overflow: 'auto',
        position: 'relative',
        border: '1px solid #e0e0e0',
        marginBottom: '60px'
      }} id="reportTable">
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead sx={{
            position: 'sticky',
            top: 0,
            zIndex: 1,
            backgroundColor: 'white'
          }}>
            <TableRow>
              <TableCell style={{ textAlign: "center", fontWeight: "bold", backgroundColor: 'white' }}>Bill No</TableCell>
              <TableCell style={{ textAlign: "center", fontWeight: "bold", backgroundColor: 'white' }}>Date</TableCell>
              <TableCell style={{ textAlign: "left", fontWeight: "bold", backgroundColor: 'white' }}>Customer Name / Party Name</TableCell>
              <TableCell style={{ textAlign: "left", fontWeight: "bold", backgroundColor: 'white' }}>GST No.</TableCell>
              <TableCell style={{ textAlign: "left", fontWeight: "bold", backgroundColor: 'white' }}>Truck No</TableCell>

              <TableCell style={{ textAlign: "left", fontWeight: "bold", backgroundColor: 'white' }}>Item Name</TableCell>
              <TableCell style={{ textAlign: "right", fontWeight: "bold", backgroundColor: 'white' }}>Net Quintal</TableCell>
              <TableCell style={{ textAlign: "right", fontWeight: "bold", backgroundColor: 'white' }}>Rate</TableCell>

              {/* <TableCell style={{ textAlign: "right", fontWeight: "bold", backgroundColor: 'white' }}>GST Rate</TableCell> */}
              <TableCell style={{ textAlign: "right", fontWeight: "bold", backgroundColor: 'white' }}>Dispatched</TableCell>
              <TableCell style={{ textAlign: "right", fontWeight: "bold", backgroundColor: 'white' }}>Balance</TableCell>
              
               </TableRow>
          </TableHead>

          <TableBody>
            {Object.entries(groupedReportData).map(([key, { items, totalQty }]) => {
              return (
                <React.Fragment key={key}>
                  {items.map((item, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        cursor: "pointer",
                        "&:hover": {
                          backgroundColor: "#fdfd96",
                        },
                      }}
                    >
                      <TableCell>{item.purcno}</TableCell>
                      <TableCell>{formatDate(item.Doc_Date)}</TableCell>
                      <TableCell style={{ textAlign: "left" }}>{item.PartyName}</TableCell>
                      <TableCell style={{ textAlign: "left" }}>{item.Gst_No}</TableCell>
                      <TableCell style={{ textAlign: "left" }}>{item.Truck_No}</TableCell>

                      <TableCell style={{ textAlign: "left" }}>{item.itemname}</TableCell>
                      <TableCell style={{ textAlign: "right" }}>

                        {formatReadableAmount(item.Purchase_Qntl)}
                      </TableCell>
                       <TableCell style={{ textAlign: "right" }}>{item.Rate}</TableCell>
                      <TableCell style={{ textAlign: "right" }}>{item.Sale}</TableCell>
                      <TableCell style={{ textAlign: "right" }}>
                        {formatReadableAmount(item.Balance)}
                      </TableCell>
                     
                    </TableRow>
                  ))}
                </React.Fragment>
              );
            })}
          </TableBody>

          <TableFooter style={{ position: 'sticky', bottom: 0, backgroundColor: 'white', zIndex: 1 }}>
            <TableRow style={{ backgroundColor: "yellow" }}>
              <TableCell colSpan={6} className="fw-bold" style={{ fontWeight: "bold", fontSize: "14px" }}>Total</TableCell>
              <TableCell className="fw-bold text-end" style={{ fontWeight: "bold", fontSize: "14px" }}>{formatReadableAmount(grandTotals.netqntl)}</TableCell>
              <TableCell className="fw-bold text-end" style={{ fontWeight: "bold", fontSize: "14px" }}></TableCell>
              <TableCell className="fw-bold text-end" style={{ fontWeight: "bold", fontSize: "14px" }}>{formatReadableAmount(grandTotals.netSale)}</TableCell>
              <TableCell className="fw-bold text-end" style={{ fontWeight: "bold", fontSize: "14px" }}>{formatReadableAmount(grandTotals.netBalance)}</TableCell>

              
            </TableRow>
          </TableFooter>
        </Table>
      </div>

      {loading && (
        <div style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 9999
        }}>
          <RingLoader size={80} />
        </div>
      )}
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default AgripurchaseRegister;
